/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Consumption_Comparison_Previous_Years_ShortInputs */



/**
* | output |
* | --- |
* | "Y-{years}" |
*
* @param {Consumption_Comparison_Previous_Years_ShortInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_previous_years_short = /** @type {((inputs: Consumption_Comparison_Previous_Years_ShortInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Previous_Years_ShortInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Y-${i?.years}`)
	return /** @type {LocalizedString} */ (`N-${i?.years}`)
});